import { Icon } from "semantic-ui-react";
import './NotAllowedToTextIcon.scss';

const NotAllowedToTextIcon = ({ primary, size, style, iconClassName = '' }) => {
    return (
        <Icon.Group {...(size ? { size } : { className: `NotAllowedToTextIcon ${iconClassName}` })} style={style}>
            <Icon disabled link className='fa-solid fa-comments' {...(primary ? { color: 'primary' } : {})} />
            <Icon size='small' corner className='fas fa-ban' color='red' />
        </Icon.Group>
    )
}

export default NotAllowedToTextIcon;
